import { useQuery } from '@tanstack/react-query';
import type { SeriesDto, MaterialCode } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface CatalogueSeriesApiResponse {
  success: boolean;
  data: SeriesDto[];
}

/**
 * Hook to fetch the series catalogue, optionally filtered by material.
 * Calls GET /catalogue/series.
 * Catalogue data is stable — cached for 5 minutes.
 */
export function useCatalogueSeries(material?: MaterialCode, windowTypeId?: number) {
  return useQuery({
    queryKey: queryKeys.catalogue.series(material, windowTypeId),
    queryFn: async () => {
      const params: Record<string, any> = {};
      if (material) params.material = material;
      if (windowTypeId) params.windowTypeId = windowTypeId;
      const response = await apiClient.get<CatalogueSeriesApiResponse>('/catalogue/series', { params });
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
